import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PortletModule } from '@gspwidget/widget-core';
import { TranslateModule } from '@ngx-translate/core';
import { ShellTabComponent } from './shell-tab.component';

@NgModule({
  declarations: [
    ShellTabComponent,
  ],
  entryComponents: [
    // ShellTabComponent,
  ],
  imports: [
    CommonModule,
    PortletModule,
    TranslateModule
  ],
  exports: [
    ShellTabComponent,
  ],
  providers: [
  ]
})
export class ShellTabModule { }
